import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

export interface EstimatedTaxMsgStyles {
    msg?: TypographyPresentationProps;
    textNote?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const estimatedTaxMsgStyles: EstimatedTaxMsgStyles = {
    wrapper: {
        css: css`
            background: #e1e7ed;
            margin: 10px;
            padding: 10px;
            border-radius: 8px;
        `,
    },
    msg: {
        css: css`
            width: 100%;
            color: ${COLORS.black};
            font-size: 13px;
            font-weight: 500;
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = estimatedTaxMsgStyles;
const EstimatedTaxMsg = ({ cart }: Props) => {

    return (
        <>
            {cart?.canCheckOut === true ? (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.msg}>{siteMessage("Estimated_Tax_Msg")}</Typography>
                </StyledWrapper>
            ): null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(EstimatedTaxMsg),
    definition: {
        displayName: "Estimated Tax Message",
        group: "Common",
    },
};

export default widgetModule;
